import { Controller } from "@hotwired/stimulus"
import { getJSON } from "../api.js"

// Badge otwartych wątków helpdesku (NEW + AWAITING_REPLY) na kafelku w management.
// Sukces → liczba w textContent; błąd → element pozostaje/staje się ukryty (bez zmyślonych zer).
export default class extends Controller {
  static values = { url: String } // /api/helpdesk-threads/open_count/

  async connect() {
    let data
    try {
      data = await getJSON(this.urlValue)
    } catch {
      this.element.hidden = true
      return
    }
    this.element.textContent = String(data.open)
    this.element.hidden = false
  }
}
